import { Form, useFormContext } from "@/components/form";
import { getDeposito } from "@/features/inventario/depositos/api/get-deposito";
import { getAllDepositos } from "@/features/inventario/depositos/api/get-all-depositos";
import DepositoManualSearch from "@/features/inventario/depositos/components/deposito-manual-search";
import { Dialog, ModalContextExtractor, ModalHeader, useOpenModal } from "@/components/modal";
import { ArticuloTransferenciaTipo } from "@/shared/types/articulo-transferencia";
import { Stack } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

export default function ArticuloTransferenciaGeneralInfoFields() {
    const openModal = useOpenModal();
    const form = useFormContext();

    return <Stack gap={2} direction={"row"} flexWrap={"wrap"}>
        <Stack flex={"1 1 80px"}>
            <Form.Select name="tipo" label="Tipo" size="small" >
                <Form.Select.Option value={ArticuloTransferenciaTipo.Envio}>Envío</Form.Select.Option>
                <Form.Select.Option value={ArticuloTransferenciaTipo.Recepcion}>Recepción</Form.Select.Option>
            </Form.Select>
        </Stack>
        <Stack flex={"2 1 150px"} direction={"row"} gap={1}>
            <Stack flex={1}>
                <Form.ModelComboBox name="depositoOrigenId" label="Depósito Origen" get={getDeposito} getAll={getAllDepositos} size="small" />
            </Stack>
            <Form.IconButton onClick={() => openModal("searchDepositoOrigen")}><SearchIcon /></Form.IconButton>
        </Stack>
        <Stack flex={"2 1 150px"} direction={"row"} gap={1}>
            <Stack flex={1}>
                <Form.ModelComboBox name="depositoDestinoId" label="Depósito Destino" get={getDeposito} getAll={getAllDepositos} size="small" />
            </Stack>
            <Form.IconButton onClick={() => openModal("searchDepositoDestino")}><SearchIcon /></Form.IconButton>
        </Stack>
        <Stack flex={"1 1 70px"}>
            <Form.DatePicker name="fecha" label="Fecha" size="small" />
        </Stack>

        <Dialog code="searchDepositoOrigen" size="lg">
            <ModalHeader>Buscar Depósito Origen</ModalHeader>
            <ModalContextExtractor>
                {({ handleClose }) => <DepositoManualSearch
                    padding={3}
                    onDepositoSelect={deposito => {
                        form.setFieldValue("depositoOrigenId", deposito.id);
                        handleClose();
                    }}
                />}
            </ModalContextExtractor>
        </Dialog>

        <Dialog code="searchDepositoDestino" size="lg">
            <ModalHeader>Buscar Depósito Destino</ModalHeader>
            <ModalContextExtractor>
                {({ handleClose }) => <DepositoManualSearch
                    padding={3}
                    onDepositoSelect={deposito => {
                        form.setFieldValue("depositoDestinoId", deposito.id);
                        handleClose();
                    }}
                />}
            </ModalContextExtractor>
        </Dialog>
    </Stack>
}